document.addEventListener("DOMContentLoaded", function (e) {
  var desktopLoop = false;
  var mobileLoop = false;
  var mobileSlidesPerView = 1.3;
  var desktopSlidesPerView = 3;
  var gallerySubmedia;

  // count slides
  var slides = document.querySelectorAll(
    ".gh-new-product-gallery .submedia-list__main .swiper-slide"
  ).length;

  // your original “enable loop” thresholds
  if (slides > 3) {
    desktopLoop = true;
    desktopSlidesPerView = 3.3;
  }
  if (slides > 2) {
    mobileLoop = true;
  }

  // your “only one slide” tweak
  if (slides === 1) {
    mobileSlidesPerView = 1;
  }

  function initSlider() {
    if (gallerySubmedia) {
      gallerySubmedia.destroy();
    }
    if (slides === 0) return;

    // match your original: middle index = ceil(count/2)
    var totalSlides = slides;
    var centerIndex = Math.ceil(totalSlides / 2) - 1;

    gallerySubmedia = new Swiper(
      ".gh-new-product-gallery .submedia-list__main", {
        // ─── MOBILE ───────────────────────────────────────────────────
        slidesPerView:    mobileSlidesPerView,
        spaceBetween:     20,
        grabCursor:       true,
        resistance:       true,
        resistanceRatio:  0.5,
        threshold:        10,

        loop:             false,              // no loop
        centeredSlides:   mobileLoop,         // only center if your original mobileLoop was true
        initialSlide:     mobileLoop ? centerIndex : 0,

        // disable dragging when nothing to scroll
        allowTouchMove:   slides > mobileSlidesPerView,

        // ─── DESKTOP @ ≥750px ────────────────────────────────────────
        breakpoints: {
          750: {
            slidesPerView:    desktopSlidesPerView,
            spaceBetween:     32,
            grabCursor:       true,
            resistance:       true,
            resistanceRatio:  0.5,
            threshold:        10,

            loop:             false,
            centeredSlides:   desktopLoop,    // only center if your original desktopLoop was true
            initialSlide:     centerIndex,    // mirror your original initialSlide

            allowTouchMove:   slides > desktopSlidesPerView,
          },
        },
      }
    );
  }

  initSlider();
});
